import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronUp } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../../Router/all_routes";
import { setToogleHeader } from "../../../core/redux/action";
// import axios from "axios";
// import { CheckCircle } from "react-feather";
// import { backendUrl } from "../../../config";
// import DateRangePicker from "../../components/DateRange/DateRangePicker";
// import moment from "moment";
// import { deleteCookie, getCookie, setCookie } from "../../common/common";
import CommonUnicommerce from "../../common/CommonUnicommerce";
// import moment from "moment";

const SalesSync = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  // const SunshineToken = localStorage.getItem("Token") || null;
  // const SunshineToken = getCookie("Token") || null;
  // const today = moment();

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // const [startDateSecond, setStartDateSecond] = useState(null);
  // const [endDateSecond, setEndDateSecond] = useState(null);

  // const [sunShineToken, setSunShineToken] = useState(SunshineToken || "");
  // const [jobCode, setJobCode] = useState("");
  // const [filePath, setFilePath] = useState("");
  // const [stepStatus, setStepStatus] = useState({
  //   generateToken: SunshineToken ? true : false,
  //   generateTokenLoading: false,
  //   createJob: false,
  //   createJobLoading: false,
  //   createJobErrorMessage: "",
  //   jobStatus: false,
  //   jobStatusLoading: false,
  //   jobStatusErrorMessage: "",
  //   exportComplete: false,
  //   exportCompleteLoading: false,
  //   exportErrorMessage: "",
  //   SyncStatus: false,
  //   SyncStatusLoading: false,
  // });

  // const [inventoryData, setInventoryData] = useState([]);

  // console.log(inventoryData, "inventoryData");

  // const generateToken = async () => {
  //   setStepStatus((prev) => ({
  //     ...prev,
  //     generateTokenLoading: true,
  //     createJob: false,
  //     createJobLoading: false,
  //     createJobErrorMessage: "",
  //     jobStatus: false,
  //     jobStatusLoading: false,
  //     jobStatusErrorMessage: "",
  //     exportComplete: false,
  //     exportCompleteLoading: false,
  //     exportErrorMessage: "",
  //     SyncStatus: false,
  //     SyncStatusLoading: false,
  //   }));
  //   try {
  //     const response = await axios.get(
  //       `${backendUrl}/unicommerce/tokengenerate`
  //     );
  //     if (
  //       response.data.ResponseCode === "SUCCESS" &&
  //       response.data.ResponseData.access_token
  //     ) {
  //       setSunShineToken(response.data.ResponseData.access_token);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         generateToken: true,
  //         generateTokenLoading: false,
  //       }));
  //       setCookie("Token", response.data.ResponseData.access_token, 3);
  //       // localStorage.setItem("Token", response.data.ResponseData.access_token);
  //       console.log(
  //         "Token generated successfully:",
  //         response.data.ResponseData.access_token
  //       );
  //     } else {
  //       console.error("Error in token response:", response.data);
  //     }
  //   } catch (err) {
  //     console.error("Error generating token:", err);
  //   }
  // };

  // const CreateSaleJobObject = {
  //   exportJobTypeName: "Sale Orders",
  //   exportColums: [
  //     "soicode",
  //     "displayorderCode",
  //     "reversePickupCode",
  //     "reversePickupCreatedDate",
  //     "reversePickupReason",
  //     "notificationEmail",
  //     "notificationMobile",
  //     "requireCustomization",
  //     "cod",
  //     "shippingAddressId",
  //     "category",
  //     "invoiceCode",
  //     "invoiceCreated",
  //     "ewbNo",
  //     "ewbDate",
  //     "ewbValidTill",
  //     "shippingAddressName",
  //     "shippingAddressLine1",
  //     "shippingAddressLine2",
  //     "shippingAddressCity",
  //     "shippingAddressState",
  //     "shippingAddressCountry",
  //     "shippingAddressPincode",
  //     "shippingAddressLatitude",
  //     "shippingAddressLongitude",
  //     "shippingAddressPhone",
  //     "billingAddressId",
  //     "billingAddressName",
  //     "billingAddressLine1",
  //     "billingAddressLine2",
  //     "billingAddressCity",
  //     "billingAddressState",
  //     "billingAddressCountry",
  //     "billingAddressPincode",
  //     "billingAddressLatitude",
  //     "billingAddressLongitude",
  //     "billingAddressPhone",
  //     "shippingMethod",
  //     "skuCode",
  //     "channelProductId",
  //     "itemTypeName",
  //     "itemTypeColor",
  //     "itemTypeSize",
  //     "itemTypeBrand",
  //     "channel",
  //     "itemRequireCustomization",
  //     "giftWrap",
  //     "giftMessage",
  //     "hsnCode",
  //     "maxRetailPrice",
  //     "totalPrice",
  //     "sellingPrice",
  //     "costPrice",
  //     "prepaidAmount",
  //     "subtotal",
  //     "discount",
  //     "gstTaxTypeCode",
  //     "cgst",
  //     "igst",
  //     "sgst",
  //     "utgst",
  //     "cess",
  //     "cgstrate",
  //     "igstrate",
  //     "sgstrate",
  //     "utgstrate",
  //     "cessrate",
  //     "TCSAmount",
  //     "tax",
  //     "taxValue",
  //     "voucherCode",
  //     "shippingCharges",
  //     "shippingMethodCharges",
  //     "cashOnDeliveryCharges",
  //     "giftWrapCharges",
  //     "packetNumber",
  //     "displayOrderDateTime",
  //     "saleOrderCode",
  //     "onhold",
  //     "status",
  //     "priority",
  //     "currency",
  //     "currencyConversionRate",
  //     "SoiStatus",
  //     "cancellationReason",
  //     "shippingProvider",
  //     "shippingCourier",
  //     "shippingArrangedBy",
  //     "ShippingPackageCode",
  //     "ShippingPackageCreationDate",
  //     "shippingPackageStatusCode",
  //     "shippingPackageTypeCode",
  //     "shippingPackageLength",
  //     "shippingPackageWidth",
  //     "shippingPackageHeight",
  //     "deliveryTime",
  //     "TrackingNumber",
  //     "dispatchDate",
  //     "facility",
  //     "returnedDate",
  //     "returnReason",
  //     "returnRemarks",
  //     "created",
  //     "updated",
  //     "combinationIdentifier",
  //     "combinationDescription",
  //     "transferPrice",
  //     "itemCode",
  //     "imei",
  //     "actualWeight",
  //     "gsttin",
  //     "Cgsttin",
  //     "tin",
  //     "paymentInstrc",
  //     "fulfillmentTat",
  //     "ajustmentInSellingPrice",
  //     "ajustmentInDiscount",
  //     "storeCredit",
  //     "irn",
  //     "acknowledgementNumber",
  //     "bundleSkuCode",
  //     "skuName",
  //     "batchCode",
  //     "vendorBatchNumber",
  //     "sellerSkuCode",
  //     "itemTypeEAN",
  //     "shippingCourierStatus",
  //     "shippingTrackingStatus",
  //     "itemSealId",
  //     "parentSaleOrderCode",
  //   ],
  //   exportFilters: [
  //     {
  //       id: "addedOn",
  //       dateRange: {
  //         start: startDate, //1736274600000,
  //         end: endDate, //1736447399999,
  //         // textRange: 'YESTERDAY'
  //       },
  //     },
  //   ],
  //   frequency: "ONETIME",
  // };

  // const createJob = async () => {
  //   try {
  //     setStepStatus((prev) => ({
  //       ...prev,
  //       createJobLoading: true,
  //       jobStatus: false,
  //       jobStatusLoading: false,
  //       jobStatusErrorMessage: "",
  //       exportComplete: false,
  //       exportCompleteLoading: false,
  //       exportErrorMessage: "",
  //       SyncStatus: false,
  //       SyncStatusLoading: false,
  //     }));
  //     const response = await axios.post(
  //       `${backendUrl}/unicommerce/exportjobcreate`,
  //       CreateSaleJobObject,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sunShineToken}`,
  //         },
  //       }
  //     );
  //     if (response.data.ResponseCode === "SUCCESS") {
  //       if (response.data.ResponseData.successful) {
  //         setJobCode(response.data.ResponseData.jobCode);
  //         setStepStatus((prev) => ({
  //           ...prev,
  //           createJob: true,
  //           createJobLoading: false,
  //           createJobErrorMessage: "",
  //         }));
  //         console.log("Job created successfully:", response.data);
  //       }
  //     } else {
  //       console.error("Error in job creation response:", response.data);
  //     }
  //   } catch (err) {
  //     if (err.status === 401) {
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         generateToken: false,
  //         generateTokenLoading: false,
  //         createJob: false,
  //         createJobLoading: false,
  //         createJobErrorMessage: "Token Failed",
  //       }));
  //       deleteCookie("Token");
  //       setSunShineToken("");
  //     }
  //     console.error("Error creating job:", err);
  //   }
  // };

  // const getJobStatus = async () => {
  //   setStepStatus((prev) => ({
  //     ...prev,
  //     jobStatusLoading: true,
  //     exportComplete: false,
  //     exportCompleteLoading: false,
  //     exportErrorMessage: "",
  //     SyncStatus: false,
  //     SyncStatusLoading: false,
  //   }));
  //   try {
  //     const response = await axios.post(
  //       `${backendUrl}/unicommerce/exportjobstatus`,
  //       { jobCode },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sunShineToken}`,
  //         },
  //       }
  //     );
  //     if (
  //       response.data.ResponseData.successful &&
  //       response.data.ResponseData.status === "SCHEDULED"
  //     ) {
  //       setFilePath("");
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         jobStatus: false,
  //         jobStatusLoading: false,
  //         jobStatusErrorMessage: "SCHEDULED Try After Sometime",
  //       }));
  //       console.log("Job completed successfully:", response.data);
  //     } else if (
  //       response.data.ResponseData.successful &&
  //       response.data.ResponseData.status === "RUNNING"
  //     ) {
  //       setFilePath("");
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         jobStatus: false,
  //         jobStatusLoading: false,
  //         jobStatusErrorMessage: "RUNNING Try After Sometime",
  //       }));
  //     } else if (
  //       response.data.ResponseData.successful &&
  //       response.data.ResponseData.status === "COMPLETE"
  //     ) {
  //       setFilePath(response.data.ResponseData.filePath);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         jobStatus: true,
  //         jobStatusLoading: false,
  //         jobStatusErrorMessage: "",
  //       }));
  //     }
  //     console.error("Error in job status response:", response.data);
  //   } catch (err) {
  //     console.error("Error fetching job status:", err);
  //   }
  // };

  // const exportInventory = async () => {
  //   console.log("File available at:", filePath);
  //   setStepStatus((prev) => ({
  //     ...prev,
  //     exportCompleteLoading: true,
  //     SyncStatus: false,
  //     SyncStatusLoading: false,
  //   }));
  //   // window.open(filePath, "_blank"); // direct download button
  //   try {
  //     const response = await axios.post(
  //       `${backendUrl}/unicommerce/exportunicommercedata`,
  //       {
  //         filePath: filePath,
  //         type: "sales",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sunShineToken}`,
  //         },
  //       }
  //     );
  //     console.log(response, "get export");
  //     if (
  //       response.data.ResponseData &&
  //       response.data.ResponseCode === "SUCCESS"
  //     ) {
  //       setInventoryData(response.data.ResponseData);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         exportComplete: true,
  //         SyncStatus: true,
  //         exportCompleteLoading: false,
  //       }));
  //       console.log("Job Export completed successfully:", response.data);
  //     } else {
  //       setInventoryData([]);
  //       setStepStatus((prev) => ({
  //         ...prev,
  //         exportComplete: false,
  //         SyncStatus: false,
  //         exportCompleteLoading: false,
  //         exportErrorMessage: "Something went wrong!",
  //       }));
  //       console.error("Error in job Export status response:", response.data);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching job status:", err);
  //   }
  // };

  // const downloadExportCSV = () => {
  //   if (filePath) {
  //     window.open(filePath); // "_blank" for open in new tab,  direct download button
  //   } else {
  //     console.log("File not Found, Please ReCreate a Job");
  //   }
  // };

  // const handleCallbackDate = (start, end) => {
  //   console.log(start, end, "handleCallbackDate");
  //   if (start) {
  //     setStartDate(start); // 2020-07-11T06:39:57.490Z
  //     const startInSecond = Math.floor(
  //       new Date(moment(start).format("YYYY-MM-DD") + " 12:00:01 AM").getTime()
  //     );
  //     setStartDateSecond(startInSecond);
  //   }
  //   if (end) {
  //     setEndDate(end);
  //     const endInSecond = Math.floor(
  //       new Date(moment(end).format("YYYY-MM-DD") + " 12:00:01 AM").getTime()
  //     );
  //     setEndDateSecond(endInSecond);
  //   }
  // };

  // console.log(startDate, endDate, "jobDateRange 1");
  // console.log(startDateSecond, endDateSecond, "jobDateRange 2");
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Sales Sync</h4>
              <h6>Manage Sales Sync</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.sales} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Sales
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="refresh-tooltip">Collapse</Tooltip>}
              >
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        
        <CommonUnicommerce type="sales" />
        {/* <div className="card">
          <div className="card-body add-product pb-0">
            <div className="accordion-card-one accordion">
              <div className="accordion-item">
                <div className="accordion-header">
                  <div className="accordion-button d-flex justify-content-between mb-2">
                    <div className="col-md-2">
                      <h5>1. Generate Token</h5>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-4">
                      {stepStatus.generateTokenLoading ? (
                        <span className="fs-5">
                          <i className="fas fa-spinner fa-spin me-2" />
                          Loading...
                        </span>
                      ) : stepStatus.generateToken ? (
                        <CheckCircle color="green" />
                      ) : (
                        <CheckCircle color="gray" />
                      )}
                    </div>
                    <div className="col-md-4">
                      <div className="page-btn" onClick={generateToken}>
                        <button className="btn btn-submit">Generate</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <div className="accordion-header">
                  <div className="accordion-button d-flex justify-content-between mb-2">
                    <div className="col-md-2">
                      <h5>2. Create Job</h5>
                    </div>
                    <div className="col-md-3">
                      <DateRangePicker
                        CallbackDate={handleCallbackDate}
                        range="Yesterday"
                      />
                    </div>

                    <div className="col-md-4">
                      {stepStatus.createJobErrorMessage ? (
                        stepStatus.createJobErrorMessage
                      ) : stepStatus.createJobLoading ? (
                        <span className="fs-5">
                          <i className="fas fa-spinner fa-spin me-2" />
                          Loading...
                        </span>
                      ) : stepStatus.createJob ? (
                        <CheckCircle color="green" />
                      ) : (
                        <CheckCircle color="gray" />
                      )}
                    </div>
                    <div className="col-md-4">
                      <div className="page-btn" onClick={createJob}>
                        <button
                          className="btn btn-submit"
                          disabled={!stepStatus.generateToken}
                        >
                          Create Job
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <div className="accordion-header">
                  <div className="accordion-button d-flex justify-content-between mb-2">
                    <div className="col-md-2">
                      <h5>3. Get Job Status</h5>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-4">
                      {stepStatus.jobStatusErrorMessage ? (
                        stepStatus.jobStatusErrorMessage
                      ) : stepStatus.jobStatusLoading ? (
                        <span className="fs-5">
                          <i className="fas fa-spinner fa-spin me-2" />
                          Loading...
                        </span>
                      ) : stepStatus.jobStatus ? (
                        <CheckCircle color="green" />
                      ) : (
                        <CheckCircle color="gray" />
                      )}
                    </div>
                    <div className="col-md-4">
                      <div className="page-btn" onClick={getJobStatus}>
                        <button
                          className="btn btn-submit"
                          disabled={!stepStatus.createJob}
                        >
                          Get Status
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <div className="accordion-header">
                  <div className="accordion-button d-flex justify-content-between mb-2">
                    <div className="col-md-2">
                      <h5>4. Export Inventory</h5>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-4">
                      {stepStatus.exportErrorMessage ? (
                        stepStatus.exportErrorMessage
                      ) : stepStatus.exportCompleteLoading ? (
                        <span className="fs-5">
                          <i className="fas fa-spinner fa-spin me-2" />
                          Loading...
                        </span>
                      ) : stepStatus.exportComplete ? (
                        <CheckCircle color="green" />
                      ) : (
                        <CheckCircle color="gray" />
                      )}
                    </div>
                    <div className="col-md-4">
                      <div className="page-btn">
                        <button
                          className="btn btn-submit me-2"
                          disabled={!stepStatus.jobStatus}
                          onClick={exportInventory}
                        >
                          Sync To DB
                        </button>
                        <button
                          className="btn btn-submit"
                          disabled={!stepStatus.SyncStatus}
                          onClick={downloadExportCSV}
                        >
                          Download CSV
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default SalesSync;
